import React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { cn } from "./utils";

export const TooltipProvider = TooltipPrimitive.Provider;
export const Tooltip = TooltipPrimitive.Root;
export const TooltipTrigger = TooltipPrimitive.Trigger;

export const TooltipContent = React.forwardRef(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        "d2c-ui tw-z-[1080] tw-max-w-xs tw-rounded-md tw-bg-slate-900 tw-px-2.5 tw-py-1.5 tw-font-sans tw-text-xs tw-leading-4 tw-text-white tw-shadow-md tw-animate-d2c-fade-in",
        className,
      )}
      {...props}
    />
  </TooltipPrimitive.Portal>
));
TooltipContent.displayName = "TooltipContent";

// Text shown on hover or keyboard focus. A disabled control gets no pointer
// events, so the trigger is a focusable wrapper span.
export const Hint = ({ text, children, className }) => {
  if (!text) return children;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span tabIndex={0} className={cn("tw-inline-flex tw-rounded-md focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring", className)}>
          {children}
        </span>
      </TooltipTrigger>
      <TooltipContent>{text}</TooltipContent>
    </Tooltip>
  );
};
